import React, { createContext, useState, useEffect } from 'react';

const AppContext = createContext();

export default AppContext;
